import styled from 'styled-components';
import { Column } from '@ant-design/plots';
import { Line } from '@ant-design/charts';

export const AnalysisPlotsContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 4rem;
`;

export const AnalysisPlotsTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 2rem;
`;

export const StyledColumn = styled(Column)`
  margin-bottom: 4rem;
`;

export const StyledLine = styled(Line)`
  margin-bottom: 4rem;
`;

export const GroupedLine = styled(Column)`
  margin-bottom: 4rem;
`;
